import { gql, useQuery } from '@apollo/client'
import { useCallback } from 'react'
import { Control, Controller } from 'react-hook-form'

import { Select } from '../../components/select'
import { Intent } from '../../config/intent'
import { productInterests } from '../../graphql/masa-types'
import { Validation } from '../../lib/validation'
import { ProfileInfoFormValues } from './profile-info-form'

export const PRODUCT_INTERESTS_QUERY = gql`
    query productInterests {
        listProductInterests {
            items {
                id
                text
            }
        }
    }
`

interface ProductInterestsSelectProps {
    control: Control<ProfileInfoFormValues>
    intent: Intent
    value: string[]
    onChange: (value: string[]) => void
}

export function ProductInterestsSelect({
    control,
    intent,
    value,
    onChange,
}: ProductInterestsSelectProps) {
    const name = 'productInterests'
    const { data, loading } = useQuery<productInterests>(
        PRODUCT_INTERESTS_QUERY,
    )

    const handleUpdate = useCallback(
        (action: any) => {
            switch (action.action) {
                case 'select-option':
                    return [...value, action.option.value]
                case 'remove-value':
                case 'pop-value':
                    return value.filter(
                        (o: any) => o !== action.removedValue.value,
                    )
                case 'clear':
                    return []
            }
        },
        [value],
    )

    return (
        <Controller
            name={name}
            control={control}
            rules={Validation.genericRequired}
            defaultValue={value}
            render={({ field }) => {
                return (
                    <Select
                        // @ts-ignore
                        options={data?.listProductInterests?.items?.map(
                            (option: any) => ({
                                label: option.text,
                                value: option.id,
                            }),
                        )}
                        value={value}
                        isMulti={true}
                        intent={intent}
                        loading={loading}
                        onChange={(selection: any, action: any) => {
                            const newValue = handleUpdate(action)
                            onChange(newValue as string[])
                        }}
                        name={name}
                        inputId={name}
                    />
                )
            }}
        />
    )
}
